import React, { FC } from 'react'
import ContentLoader from 'react-content-loader'

const ContentFetching: FC = () => (
  <ContentLoader height={44} width={200}>
    <rect x="0" y="4" rx="8" ry="8" width="130" height="16" />
    <rect x="0" y="28" rx="8" ry="8" width="200" height="16" />
  </ContentLoader>
)

export { ContentFetching }
